import { logger } from '../logger';
import { registerSleeknote } from './sleeknote';
export var ddSleeknotePlugin = function (options) {
    return {
        name: 'Sleeknote',
        type: 'utility',
        version: '0.0.1',
        isLoaded: function () { return true; },
        load: function (ctx, analytics) {
            logger.debug('Enabling Sleeknote plugin');
            var sleeknoteOptions = options.sleeknote;
            registerSleeknote(analytics, sleeknoteOptions);
            return Promise.resolve(ctx);
        },
    };
};
//# sourceMappingURL=index.js.map